import React from 'react';

const SettingContainer = ({ children, title, icon, Menu }) => {
    // Theme constant to match your app's new look
    const themeColor = "#4F46E5";

    return (
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: '16px', overflow: 'hidden' }}>
            <div 
                className="card-header bg-white d-flex align-items-center justify-content-between py-3" 
                style={{ 
                    borderBottom: '1px solid #F1F5F9',
                    minHeight: '65px'
                }}
            >
                {/* Left Side: Title & Icon */}
                <div className="d-flex align-items-center">
                    <div 
                        className="d-flex align-items-center justify-content-center mr-3"
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            backgroundColor: '#EEF2FF', // Light Indigo wash
                        }}
                    >
                        <i className={`${icon}`} style={{ color: themeColor, fontSize: '16px' }}></i>
                    </div>
                    <h5 className="mb-0" style={{ 
                        fontSize: '17px', 
                        fontWeight: '700', 
                        color: '#1A202C',
                        letterSpacing: '-0.01em',
                        textTransform: 'capitalize'
                    }}>
                        {title}
                    </h5>
                </div>

                {/* Right Side: Options Menu */}
                {Menu && (
                    <div className="dropdown">
                        <button 
                            type="button" 
                            data-toggle="dropdown" 
                            className="btn btn-link p-0 d-flex align-items-center justify-content-center"
                            style={{ 
                                width: '36px', 
                                height: '36px', 
                                borderRadius: '8px',
                                color: '#64748B',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F1F5F9'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            <i className="fa fa-ellipsis-v" style={{ fontSize: '18px' }}></i>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right shadow-lg border-0 mt-2" style={{ borderRadius: '12px', padding: '8px' }}>
                            <div className="px-3 py-2 mb-1" style={{ fontSize: '11px', fontWeight: '800', color: '#94A3B8', textTransform: 'uppercase' }}>
                                Options
                            </div>
                            <div className="custom-menu-wrapper">
                                <Menu />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Body Content */}
            <div className="card-body p-4" style={{ backgroundColor: '#FCFDFF' }}>
                {children}
            </div>

            <style>{`
                /* Ensure Menu items look professional inside the new dropdown */
                .custom-menu-wrapper .dropdown-item {
                    border-radius: 6px;
                    font-size: 14px;
                    padding: 8px 12px;
                    color: #475569;
                }
                .custom-menu-wrapper .dropdown-item:hover {
                    background-color: #F8FAFC;
                    color: ${themeColor};
                }
                .custom-menu-wrapper i {
                    margin-right: 10px;
                    width: 16px;
                    text-align: center;
                }
            `}</style>
        </div>
    );
};

export default SettingContainer;